module.exports = __webpack_public_path__ + "img/segovia.f535ce9e.jpg";